(() => {
  const formatPhone = (value) => {
    const hasPlus = value.trim().startsWith("+");
    const digits = value.replace(/\D/g, "").slice(0, 15);
    if (!digits) return "";

    if (hasPlus && digits.startsWith("64")) {
      const local = digits.slice(2);
      if (local.length === 8)
        return `+64 ${local.slice(0, 1)} ${local.slice(1, 4)} ${local.slice(4)}`.trim();
      if (local.length >= 9)
        return `+64 ${local.slice(0, 2)} ${local.slice(2, 5)} ${local.slice(5)}`.trim();
      return `+64 ${local}`.trim();
    }

    if (!hasPlus && digits.startsWith("0")) {
      if (digits.length === 9)
        return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
      if (digits.length === 10)
        return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
      if (digits.length === 11)
        return `${digits.slice(0, 3)} ${digits.slice(3, 7)} ${digits.slice(7)}`;
    }

    const groups = digits.match(/.{1,3}/g)?.join(" ") || digits;
    return hasPlus ? `+${groups}` : groups;
  };

  const init = (section) => {
    if (section.dataset.contactFormReady === "true") return;
    section.dataset.contactFormReady = "true";

    const form = section.querySelector("[data-contact-form]");
    if (!form) return;

    const messages = form.querySelector("[data-contact-validation-messages]");
    const phone = form.querySelector("[data-contact-phone]");
    const submit = form.querySelector("[data-contact-submit]");
    const requiredMessage =
      messages?.dataset.requiredMessage ||
      "Please complete this required field.";
    const emailMessage =
      messages?.dataset.emailMessage || "Please enter a valid email address.";
    const phoneMessage =
      messages?.dataset.phoneMessage || "Please enter a valid phone number.";

    const validatePhone = () => {
      if (!phone) return true;
      const digitCount = phone.value.replace(/\D/g, "").length;
      phone.setCustomValidity(
        phone.value && (digitCount < 7 || digitCount > 15) ? phoneMessage : "",
      );
      return phone.checkValidity();
    };

    phone?.addEventListener("input", () => {
      const leadingPlus = phone.value.trim().startsWith("+");
      const digits = phone.value.replace(/\D/g, "").slice(0, 15);
      phone.value = `${leadingPlus ? "+" : ""}${digits}`;
      validatePhone();
    });
    phone?.addEventListener("blur", () => {
      phone.value = formatPhone(phone.value);
      validatePhone();
    });

    form.querySelectorAll("input, textarea").forEach((field) => {
      field.addEventListener("input", () => {
        if (field !== phone) field.setCustomValidity("");
      });
      field.addEventListener("invalid", () => {
        if (field.validity.valueMissing)
          field.setCustomValidity(requiredMessage);
        else if (field.type === "email" && field.validity.typeMismatch)
          field.setCustomValidity(emailMessage);
        else if (field === phone) validatePhone();
      });
    });

    form.addEventListener("submit", (event) => {
      validatePhone();
      if (!form.checkValidity()) return;
      if (submit) {
        submit.disabled = true;
        submit.textContent = messages?.dataset.submittingLabel || "Sending...";
      }
    });
  };

  const initAll = (scope = document) =>
    scope.querySelectorAll("[data-contact-form-section]").forEach(init);

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) =>
    initAll(event.target),
  );
})();
